import { ChamadaFinal } from "@/features/landing/components/ChamadaFinal";
import { Ciclo } from "@/features/landing/components/Ciclo";
import { Declaracao } from "@/features/landing/components/Declaracao";
import { Grade, type ItemDaGrade } from "@/features/landing/components/Grade";
import { Heroi } from "@/features/landing/components/Heroi";
import { Topo } from "@/features/landing/components/Topo";
import "@/features/landing/landing.css";
import { useCanonical } from "@/features/landing/hooks/useCanonical";
import { useRolarParaAncora } from "@/features/landing/hooks/useRolarParaAncora";

/**
 * Landing publica, servida na raiz do dominio para quem nao esta logado.
 *
 * E a landing GERAL: o produto atende qualquer segmento que vende e atende pelo
 * WhatsApp, entao aqui nao se cita segmento nenhum.
 *
 * Tom de voz: direto, problema e solucao. Nada de frase de efeito nem metafora;
 * cada bloco diz o que da errado hoje e o que o sistema faz a respeito.
 *
 * Linguagem visual: painel de SaaS claro, com o laranja Flame da marca como
 * unico destaque. Ver o cabecalho de landing.css e src/styles/tokens.css.
 */
export function LandingPage() {
  useCanonical("https://samev.com.br/");
  useRolarParaAncora();

  return (
    <div className="lp">
      <div className="lp-listra" />

      <div className="lp-largura">
        <Topo />
        <Heroi
          rotulo="CRM para WhatsApp"
          titulo={
            <>
              Aumente suas <span className="lp-destaque">vendas no WhatsApp</span> com uma solução
              completa e avançada.
            </>
          }
          texto="Atendimento da equipe, funil de vendas, agente de IA e relatórios num só sistema, conectado ao número que você já usa."
        />
      </div>

      <div className="lp-largura">
        <Grade
          id="problemas"
          rotulo="O que o Samev resolve"
          titulo="Os problemas que fazem você perder venda no WhatsApp"
          itens={PROBLEMAS}
        />
        <Ciclo
          id="recompra"
          rotulo="Recompra"
          titulo="Venda de novo para quem já comprou"
          texto="A maioria das empresas perde o cliente depois da primeira compra porque ninguém acompanha. No Samev, quando um cliente antigo manda mensagem, o atendimento reabre sozinho com todo o histórico de compras. Você sabe quem voltou, quanto comprou e quem atendeu."
        />
        <Grade
          id="para-quem"
          rotulo="Para quem"
          titulo="Para empresas que vendem pelo WhatsApp"
          itens={PARA_QUEM}
        />
        <Declaracao id="recursos" rotulo="Recursos" titulo="Tudo o que está incluso" conteudo={CONTEUDO} />
      </div>

      <ChamadaFinal titulo="Comece hoje a vender mais pelo WhatsApp." />
    </div>
  );
}

/** Rotulo e o problema, titulo e a solucao, texto e como funciona. */
const PROBLEMAS: ItemDaGrade[] = [
  {
    rotulo: "Cliente sem resposta",
    titulo: "Todos os números numa fila só",
    texto:
      "Mensagem que ninguém viu é venda perdida. Sua equipe atende todos os WhatsApps da empresa numa tela, com alerta de quem está esperando demais.",
  },
  {
    rotulo: "Dois atendentes no mesmo cliente",
    titulo: "Cada conversa tem um responsável",
    texto:
      "Quem assume a conversa fica como responsável por ela. Transferir é um clique, e a nota interna explica o caso para o próximo.",
  },
  {
    rotulo: "Não saber quanto vendeu",
    titulo: "Venda registrada na conversa",
    texto:
      "Fechou, a equipe registra valor e data ali mesmo. O relatório mostra vendas por atendente e conversão por origem do cliente.",
  },
  {
    rotulo: "Não saber por que perdeu",
    titulo: "Motivo de perda obrigatório",
    texto:
      "Finalizar um atendimento sem venda pede o motivo: preço, sumiu, comprou em outro lugar. No fim do mês você sabe o que corrigir.",
  },
  {
    rotulo: "Mensagem fora do horário",
    titulo: "Agente de IA que responde 24 horas",
    texto:
      "Responde com base nas suas perguntas frequentes, envia vídeo, foto e PDF e passa para a equipe quando não resolve.",
  },
  {
    rotulo: "Cliente pedindo catálogo",
    titulo: "Vitrine de produtos com link",
    texto:
      "Cadastre produtos com preço e variação. A equipe e o agente mandam o link do produto certo na conversa.",
  },
];

const PARA_QUEM: ItemDaGrade[] = [
  {
    rotulo: "Comércio",
    titulo: "Lojas, revendas e e-commerce",
    texto: "Responda preço, pedido e troca rápido e acompanhe quem já comprou de você.",
  },
  {
    rotulo: "Serviços",
    titulo: "Clínicas, escritórios e agências",
    texto: "Controle os orçamentos enviados e retorne para quem ainda não fechou.",
  },
  {
    rotulo: "Recorrência",
    titulo: "Cursos, assinaturas e manutenção",
    texto: "Separe clientes ativos de leads e atenda cada um com o histórico completo.",
  },
  {
    rotulo: "Suporte",
    titulo: "Times de atendimento",
    texto:
      "Distribua as conversas, cumpra o prazo de resposta e meça a produtividade de cada atendente.",
  },
];

const CONTEUDO: [string, string][] = [
  ["Caixa de entrada do WhatsApp, em tempo real", "ilimitada"],
  ["Números de WhatsApp conectados", "quantos precisar"],
  ["Contatos e histórico de atendimentos", "ilimitados"],
  ["Funis e status configuráveis com Kanban", "incluso"],
  ["Registro de vendas e motivo de perda", "incluso"],
  ["Filas, SLA e notas internas", "incluso"],
  ["Catálogo de produtos e vitrine pública", "incluso"],
  ["Relatórios de atendimento, equipe e conversão", "incluso"],
  ["Conversas atendidas pelo agente de IA", "conforme o plano"],
  ["Usuários da equipe", "conforme o plano"],
];
